import React from 'react';

import { Alert, AlertTitle } from '@mui/material';
import { useDispatch } from 'react-redux';

import { hideAlert } from '../../store/actions/alertActions';
import { useResponsive } from '../../hooks/useResponsive';


export const AlertNoti = ({title, content, severity, role}) => {
  /**
   * Accessibility infos: https://mui.com/material-ui/react-alert/#accessibility
   *                      https://www.w3.org/TR/wai-aria-practices/[id^="alert_"]
   */
  const dispatch = useDispatch();
  const isMobile = useResponsive();
  return (
    <>
      <Alert
        id={`alert_${severity}`} 
        sx={{
          maxWidth: isMobile ? 'max-content' : '15vw',
        }}
        role={role}
        severity={severity} 
        onClose={() => {
          dispatch(hideAlert());
        }}>
        <AlertTitle sx={{
        }}>{title ?? 'Erreur'}
        </AlertTitle>
        {content ?? 'This is an error'}
      </Alert>
    </>
  );
};
